
import { defineComponent } from "vue";

export default defineComponent({
  props: ["baseUrl"],
  
  name: "App",
  components: {
    // Your components here
  },
  devServer: {
    https: true,
  },
  data() {
    return {
      companyName: localStorage.getItem("companyNameForHeader") || (window as any).COMPANY_NAME_FOR_HEADER || "",
      companyIconFileName: localStorage.getItem("companyIconFile") || (window as any).ICON_FILE || "",
      isLogginSuccessfull: false,
      brandingLoaded: false,
    };
  },
  methods: {
    logout() {
      this.isLogginSuccessfull = false;
      localStorage.setItem("isLogginSuccessfull", "false");
    },
    
    setLoginStatus(message: boolean) {
      this.isLogginSuccessfull = message;
      var isLogginSuccessfulls = localStorage.getItem("isLogginSuccessfull");
    },
    
    onMessage() {
      // handle the event
    },
    
    Carousel() {
      window.addEventListener("message", this.onMessage);
    },
  
    async loadBranding() {
      try {
        const tenantId = window.location.hostname.split('.')[0].toUpperCase();
        const requestUrl = (window as any).VUE_APP_API_KEY + "Login/Settings";
        
        const response = await fetch(requestUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Tenant-ID': tenantId
          }
        });
        
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        
        const branding = await response.json();
        
        // Set window variables
        (window as any).SITE_TITLE = branding.branding.companyName;
        (window as any).COMPANY_NAME = branding.branding.companyName;
        (window as any).COMPANY_NAME_FOR_HEADER = branding.branding.companyName;
        (window as any).ICON_FILE = branding.faviconFile;
        (window as any).WHATSAPP_NUMBER = branding.branding.mobileNo;
        

          // Debug: Check if WhatsApp number is being received
          console.log("WhatsApp Number from API:", branding.branding.mobileNo);
          console.log("localStorage.setItem(whatsappNumber):", localStorage.getItem("whatsappNumber"));

        // Update localStorage for persistence across components
        localStorage.setItem("companyNameForHeader", branding.branding.companyName);
        localStorage.setItem("companyIconFile", branding.faviconFile);
        localStorage.setItem("whatsappNumber", branding.branding.mobileNo);  // ✅ ADD THIS LINE
        localStorage.setItem("companyName", branding.branding.companyName);  // ✅ ADD THIS LINE
        
        // After your localStorage.setItem lines, add this:
        window.dispatchEvent(new Event('brandingLoaded'));


        

        // Update your component's reactive data
        this.companyName = branding.branding.companyName;
        this.companyIconFileName = branding.faviconFile;

        // Tell all components that branding is ready
        //window.dispatchEvent(new Event('brandingLoaded'));
        
        document.title = branding.branding.companyName;
        this.brandingLoaded = true;
        
      } catch (error) {
        console.error("Failed to load branding:", error);
        this.brandingLoaded = true;
      }
    }
  },

  computed: {},
  
  mounted() {
    console.log("=== MOUNTED HOOK CALLED ===");
    console.log("baseUrl prop value:", this.baseUrl);
    
    // Call loadBranding
    this.loadBranding();
    
    var isloggedSuccessfully = localStorage.getItem("isLogginSuccessfull");
    if (isloggedSuccessfully == "true") this.isLogginSuccessfull = true;
    else this.isLogginSuccessfull = false;

    this.isLogginSuccessfull = Boolean(
      localStorage.getItem("isLogginSuccessfull")
    );
    
    console.log("Mounted completed. isLogginSuccessfull:", this.isLogginSuccessfull);
  },
});
